import { homeIcon } from "@/home/home-icons";

export function skillsModalMarkup(): string {
  return `
    <div id="home-skills-modal" class="home-character-modal home-skills-modal" hidden aria-hidden="true">
      <button type="button" class="home-character-backdrop" data-close-skills-modal aria-label="ปิด"></button>
      <div class="home-character-dialog home-skills-dialog" role="dialog" aria-modal="true" aria-labelledby="home-skills-title">
        <header class="home-character-head">
          <h2 id="home-skills-title" class="home-character-title">จัดการสกิล</h2>
          <button type="button" class="btn btn-ghost btn-icon" data-close-skills-modal aria-label="ปิด">
            ${homeIcon("close")}
          </button>
        </header>
        <div id="home-skills-panel-host" class="home-skills-panel-host"></div>
      </div>
      <div id="home-skill-editor-modal" class="home-skill-editor-modal" hidden aria-hidden="true">
        <button type="button" class="home-skill-editor-backdrop" data-close-skill-editor aria-label="ปิด"></button>
        <div class="home-skill-editor-dialog" role="dialog" aria-modal="true" aria-labelledby="skill-editor-title">
          <div id="home-skill-editor-host" class="home-skill-editor-host"></div>
        </div>
      </div>
    </div>
  `;
}
